"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _intlTs = require("@gogame/intl-ts");
var useDateControl = function useDateControl(_ref, _ref2) {
  var onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    name = _ref.name,
    valueProp = _ref.value;
  var template = _ref2.template,
    timeZone = _ref2.timeZone;
  var value = (0, _react.useMemo)(function () {
    return (0, _intlTs.fromUTCToTimeZone)((0, _intlTs.toDate)(valueProp), timeZone);
  }, [valueProp, timeZone]);
  var getFormattedString = (0, _intlTs.useDateFormat)({
    template: template,
    timeZone: 'local',
    empty: ''
  });
  var getFormattedArray = (0, _intlTs.useDateRangeFormat)({
    template: template,
    timeZone: 'local',
    empty: ''
  });
  var format = function format(localValue) {
    if (Array.isArray(localValue)) {
      var result = getFormattedArray(localValue);
      if (Array.isArray(result)) {
        return result.join(' - ');
      }
      return result;
    } else {
      return getFormattedString(localValue);
    }
  };
  var _defineTargetRef = (0, _react.useRef)(function () {});
  _defineTargetRef.current = function (event) {
    event.persist && event.persist();
    // Preact support, target is read only property on a native event.
    Object.defineProperty(event, 'target', {
      writable: true,
      value: {
        value: value,
        name: name
      }
    });
  };
  var handleBlur = (0, _react.useCallback)(function (event) {
    if (onBlur) {
      _defineTargetRef.current(event);
      onBlur(event, event.target);
    }
  }, [onBlur]);
  var handleFocus = (0, _react.useCallback)(function (event) {
    if (onFocus) {
      _defineTargetRef.current(event);
      onFocus(event, event.target);
    }
  }, [onFocus]);
  var handleChange = (0, _react.useCallback)(function (newValue, presetKey) {
    if (onChange) {
      var isoValue = (0, _intlTs.toISOString)((0, _intlTs.fromTimeZoneToUTC)(newValue, timeZone));
      var target = {
        name: name,
        value: isoValue
      };
      onChange({
        target: target
      }, isoValue, presetKey);
    }
  }, [onChange, name, timeZone]);
  return {
    format: format,
    value: value,
    name: name,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  };
};
var _default = exports["default"] = useDateControl;